export default "__VITE_ASSET__BDS5gZSr__"